import { Component, computed, input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { Offer, HubOfferKey } from '../../models/offers.model';

@Component({
  selector: 'app-loan-card-image',
  imports: [NgOptimizedImage],
  templateUrl: './loan-card-image.component.html',
})
export class LoanCardImageComponent {
  readonly offer = input<Offer>();
  readonly HubOfferKey = HubOfferKey;
  readonly maxAmountThousands = computed(() => {
    const raw = this.offer()?.maxAmount;
    if (raw == null || (typeof raw === 'string' && raw === '')) {
      return '';
    }

    const n = Number(raw);
    if (Number.isNaN(n)) {
      return '';
    }

    const thousands = Math.round(n / 1000);
    if (thousands <= 0) {
      return '';
    }

    return String(thousands);
  });
  readonly roundedMinApr = computed(() => {
    const minApr = this.offer()?.minApr;
    if (minApr == null) {
      return '';
    }

    const rounded = Math.round(minApr);
    if (Number.isNaN(rounded)) {
      return '';
    }

    return String(rounded);
  });
}
